<template>
  <div id="app">
    <Home></Home>
  </div>
</template>

<script>
import Home from "./views/Home.vue";
export default {
  name: "App",
  components: {
    Home,
  },
};
</script>

<style>
#app {
  font-family: SourceHanSansCN-Normal, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin: 0;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body {
  margin: 0;
  -webkit-overflow-scrolling: touch;
  height: 100vh;
  overflow: hidden;
}
</style>
